import { Locale } from "../../core/api/model";

interface Props {
  locale: Locale;
  showErrorModal: (title: string, description: string, raw?: any) => void;
}

export const MeetingProfile = ({ locale }: Props) => {
  return null;
};
